import { FC, useEffect, useState } from "react";
import { Collapse, Container, Paper } from "@mui/material";
import Grid from "@mui/material/Grid";
import GameOverviewTable from "./footer/GameOverviewTable";
import CurrentScore from "../CurrentScore";
import FooterTeamLineup from "./footer/FooterTeamLineup";
import { useResponsiveContext } from "@context/ResponsiveContext";

const ChallengeDetailPageFooter: FC = () => {
  const [collapsed, setCollapsed] = useState(false);
  const { onTablet } = useResponsiveContext();
  const [minimize, setMinimize] = useState(false);

  useEffect(() => {
    setMinimize(collapsed || onTablet);
  }, [collapsed, onTablet]);

  return (
    <Paper
      sx={{
        flexShrink: 0,
        py: 1,
        cursor: onTablet ? "auto" : minimize ? "n-resize" : "s-resize",
      }}
      elevation={5}
      onClick={() => setCollapsed(!collapsed)}
      variant={"elevation"}
      square
    >
      <Collapse in={!minimize || onTablet} collapsedSize={65}>
        <Container sx={{ px: onTablet ? 1 : 2 }}>
          <Grid
            container
            columns={{ xs: 5, md: 7 }}
            display={"flex"}
            justifyContent={"center"}
          >
            <Grid
              size={{ xs: 2, md: 2 }}
              order={1}
              display={"flex"}
              alignItems={"center"}
              justifyContent={minimize ? "end" : "center"}
              pr={2}
            >
              <FooterTeamLineup side={"left"} collapsed={minimize} />
            </Grid>
            <Grid
              size={1}
              order={2}
              display={onTablet ? "flex" : "none"}
              alignItems={"center"}
              justifyContent={"center"}
            >
              <CurrentScore
                hideOnLost={true}
                fontSize={"24px"}
                withSetScore={true}
              />
            </Grid>
            <Grid
              size={{ xs: 5, md: 3 }}
              order={onTablet ? 4 : 2}
              display={"flex"}
              alignItems={"center"}
              justifyContent={"center"}
            >
              <GameOverviewTable
                showCurrentSetOnly={minimize}
                showChallenges={true}
              />
            </Grid>
            <Grid
              size={{ xs: 2, md: 2 }}
              order={onTablet ? 3 : 3}
              display={"flex"}
              alignItems={"center"}
              justifyContent={minimize ? "start" : "center"}
              pl={2}
            >
              <FooterTeamLineup side={"right"} collapsed={minimize} />
            </Grid>
          </Grid>
        </Container>
      </Collapse>
    </Paper>
  );
};

export default ChallengeDetailPageFooter;
